import HomePage from '../pages/home.f7.html';
import SearchPage from '../pages/search.f7.html';
import RestArea from '../pages/rest-area.f7.html';
import WriteReview from '../pages/write-review.f7.html';
import RegionPage from '../pages/region.f7.html';

import DynamicRoutePage from '../pages/dynamic-route.f7.html';
import RequestAndLoad from '../pages/request-and-load.f7.html';
import NotFoundPage from '../pages/404.f7.html';

import gql from 'graphql-tag';

async function getToken(token) {
  const { data } = await __APOLLO_CLIENT__.mutate({
    mutation: gql`
      mutation ($token: String!) {
        login(provider: KAKAO, token: $token){
          authToken
        }
      }
    `,
    variables: {
      token: token,
    },
  });

  return data.login.authToken;
};

function checkAuth() {
  const login = () => {
    if (!window.KakaoCordovaSDK) {
      return;
    }

    KakaoCordovaSDK.login({}, object => {    
      getToken(object.accessToken).then(token => {
        localStorage.setItem(`token`, token);
      });
      
      return;
    }, error => {
      console.log(error);
      login();
    });
  };
    
  return {
    loading() {
      if (document.readyState !== `complete`) {
        window.onload = () => {
          login();
        }        
        return null;
      }

      return this;
    },
    load() {
      login();

      return this;
    }
  }
}

var routes = [
  {
    path: '/',
    component: HomePage,
    beforeEnter: function (routeTo, routeFrom, resolve, reject) {      
      const kakaoLogin = (resolve) => {
        if (!window.KakaoCordovaSDK) {
          resolve();
          return;
        }
        
        KakaoCordovaSDK.login({}, object => {
          getToken(object.accessToken).then(token => {
            localStorage.setItem(`token`, token);
          });          
          resolve();
        }, error => {
          console.error(error);
          kakaoLogin();
        });
      }

      kakaoLogin(resolve);
    },
  },
  {
    path: '/region/:id',
    component: RegionPage,
    on: {
      pageAfterIn: () => {
        checkAuth()
          .loading()
          ?.load();
      }
    },
  },
  {
    path: '/search/',
    component: SearchPage,    
    on: {
      pageAfterIn: () => {
        checkAuth()
          .loading()
          ?.load();
      }
    }
  },
  {
    path: '/rest-area/:id',
    component: RestArea,
    options: {
      transition: 'f7-cover',
    },    
    on: {
      pageAfterIn: () => {
        checkAuth()
          .loading()
          ?.load();
      }
    }
  },
  {
    path: '/write-review/:id',
    component: WriteReview,
    options: {
      transition: 'f7-cover-v',
      iosSwipeBack: false,
    },
    on: {
      pageAfterIn: () => {
        checkAuth()
          .loading()
          ?.load();
      }
    }
  },
  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage,
  },
  {
    path: '/request-and-load/user/:userId/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = routeTo.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            context: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;